import { hotjar } from 'react-hotjar'

export default () => {
	// eslint-disable-next-line no-undef
	if (HOTJAR_ID) {
		// eslint-disable-next-line no-undef
		hotjar.initialize(HOTJAR_ID, HOTJAR_VERSION)
	}
}
